import { type GetDataIngestionSourcesResponse } from '../../types';

import { DATA_SOURCE_TO_MODULES_IMPACTED_MAP } from './data-source-to-modules-impacted-map';

/**
 * The BE may return sources the FE does not yet know how to render
 * (icon / translation / impacted-modules mapping). For an easier adoption
 * and avoid co-ordinating releases, drop them here so
 * downstream code only ever sees fully-mapped sources.
 */
export const getKnownSources = (
  sources: GetDataIngestionSourcesResponse['sources'],
): GetDataIngestionSourcesResponse['sources'] =>
  sources.filter((source) =>
    Object.hasOwn(DATA_SOURCE_TO_MODULES_IMPACTED_MAP, source.name),
  );
